import * as Actions from '../actions'
import moment from 'moment'
import { ACTION_NEW, GENERAL_DIALOG } from 'app/constants/compose'
const initialState = {
  isOpen: false,
  notificationId: undefined,
  onCreateSuccess: undefined,
  initialValues: undefined,
  updateAt: undefined,
  type: GENERAL_DIALOG,
  action: ACTION_NEW,
}

const createNotification = function (state = initialState, action) {
  switch (action.type) {
    case Actions.OPEN_CREATE_NOTIFICATION_DIALOG: {
      return {
        ...state,
        isOpen: true,
        initialValues: action.payload.initialValues,
        onCreateSuccess: action.payload.onCreateSuccess,
        type: action.payload.type,
        notificationId: action.payload.notificationId,
        action: action.payload.action,
      }
    }
    case Actions.CLOSE_CREATE_NOTIFICATION_DIALOG: {
      return {
        ...state,
        isOpen: false,
        notificationId: undefined,
        initialValues: undefined,
        updateAt: undefined,
        type: GENERAL_DIALOG,
        action: ACTION_NEW,
      }
    }
    case Actions.SET_DRAFT_COUNT: {
      return { ...state, draftCount: action.draftCount }
    }
    case Actions.ON_CREATE_SUCCESS: {
      return {
        ...state,
        isOpen: false,
        updateAt: moment(),
      }
    }

    case Actions.ON_CREATE_DRAFT_SUCCESS: {
      return {
        ...state,
        updateAt: moment(),
        isOpen: false,
        onCreateSuccess: undefined,
      }
    }
    case Actions.OPEN_CREATE_NOTIFICATION_DIALOG_FROM_GROUP: {
      return {
        ...state,
        isOpen: true,
        onCreateSuccess: action.payload.onCreateSuccess,
      }
    }
    case Actions.UPDATE_FETCH_TIMELINE_FUNCTION:
      return {
        ...state,
        onCreateSuccess: action.payload.onCreateSuccess,
      }
    case Actions.CHANGE_TYPE_DIALOG:
      return {
        ...state,
        type: action.payload,
      }
    case Actions.CLEAR_INITAIL_VALUE:
      return {
        ...state,
        initialValues: undefined,
      }
    default: {
      return state
    }
  }
}

export default createNotification
